var c = Object.defineProperty;
var i = (t, s, e) => s in t ? c(t, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[s] = e;
var a = (t, s, e) => i(t, typeof s != "symbol" ? s + "" : s, e);
const p = "https://api.pinpayments.com";
class u {
  constructor({ publicKey: s }) {
    a(this, "baseUrl");
    a(this, "publicKey");
    a(this, "createCard", async (s) => await this._post("/1/cards", { ...s }));
    a(this, "_post", async (s, e) => {
      const n = new Headers();
      n.append("Content-Type", "application/json");
      const r = await fetch(`${this.baseUrl}${s}`, {
        method: "POST",
        body: JSON.stringify({ ...e, publishable_api_key: this.publicKey }),
        headers: n
      }), o = await r.json();
      return r.ok ? {
        success: !0,
        data: o
      } : {
        success: !1,
        error: o
      };
    });
    this.baseUrl = p, this.publicKey = s;
  }
}
export {
  u as Payments
};
//# sourceMappingURL=payments.js.map
